import React, { useState, useEffect } from 'react';
import apiClient from '../../utils/api';
import './PractitionerRecommendationWidget.css';

function PractitionerRecommendationWidget() {
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRecommendations();
  }, []);

  const loadRecommendations = async () => {
    try {
      const data = await apiClient.getUserRecommendations();
      setRecommendations(data);
    } catch (error) {
      console.error('Error loading recommendations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStatus = async (recId, status) => {
    try {
      await apiClient.updateRecommendationStatus(recId, status);
      loadRecommendations();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  if (loading || recommendations.length === 0) {
    return null;
  }

  return (
    <div className="practitioner-rec-widget" data-testid="practitioner-recommendations">
      <div className="widget-header">
        <h3>💫 Empfehlungen von deinem Therapeuten</h3>
      </div>
      
      <div className="recommendations-carousel">
        {recommendations.map((rec) => (
          <div 
            key={rec.id} 
            className="rec-card" 
            style={{ borderLeftColor: rec.frequency_color }}
            data-testid="recommendation-card"
          >
            <div className="rec-card-header">
              <span className="rec-frequency-name">
                {rec.frequency_icon} {rec.frequency_name}
              </span>
              <span className="rec-practitioner">von {rec.practitioner_name}</span>
            </div>
            <h4 className="rec-title">{rec.title}</h4>
            <p className="rec-description">{rec.description}</p>
            <div className="rec-actions">
              <button
                onClick={() => handleUpdateStatus(rec.id, 'completed')}
                className="btn-complete"
                data-testid="complete-button"
              >
                ✅ Erledigt
              </button>
              <button
                onClick={() => handleUpdateStatus(rec.id, 'dismissed')}
                className="btn-dismiss"
                data-testid="dismiss-button"
              >
                🔕 Ausblenden
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PractitionerRecommendationWidget;
